import api from './api';

export default {
  async getSubmissions(params = {}) {
    const { data } = await api.get('/admin/resources/submissions', { params });
    return data;
  },

  async approveResource(id, payload = {}) {
    const { data } = await api.post(`/admin/resources/${id}/approve`, payload);
    return data;
  },

  async rejectResource(id, payload = {}) {
    const { data } = await api.post(`/admin/resources/${id}/reject`, payload);
    return data;
  },
};
